<template>
    <div class="wrapper" style="width: 100%; margin-top: 20px;">
        <div style="width: 25%;">
            <div style="display: flex; justify-content: end">
                <SidebarMenu sidebarTitle="系统设置" :menu-list="menuList" :active-menu="activeMenu" @menu-click="handleMenuClick"/>
            </div>
        </div>
        <div style="width: 2%;"></div>
        <div style="width: 78%; padding: 0 2rem 0 0;">
            <div v-if="active !== 'mapTagManagement'">
                <div class="content-header">
                    <h1 class="content-title">{{ currentMenuTitle }}</h1>
                    <p class="content-subtitle">{{ currentMenuDesc }}</p>
                </div>
                <div class="weather-content">
                    <AppVersion v-if="active === 'version'" />
                    <LogIndex v-else-if="active === 'log'" />
                    <DatadictIndex v-else-if="active === 'do'" />
                    <UserIndex v-else-if="active === 'userControl'" />
                    <RoleIndex v-else-if="active === 'roleManagement'" />
                    <MenuIndex v-else-if="active === 'menuManagement'" />
                    <PermissionIndex v-else-if="active === 'authorityManagement'" />
                </div>
            </div>
            <router-view v-else></router-view>
        </div>
    </div>
</template>

<script>
import SidebarMenu from "@/components/water-affairs-style/sidebarMenu.vue";
import AppVersion from "./app-version/index.vue";
import LogIndex from "./log/index.vue";
import MenuIndex from "./menu/index.vue";
import RoleIndex from "./role/index.vue";
import UserIndex from "./user/index.vue";
import PermissionIndex from "./permission/index.vue";
import DatadictIndex from "./data-dict/index.vue";

export default {
    components: {
        SidebarMenu,AppVersion,LogIndex,MenuIndex,RoleIndex,UserIndex,PermissionIndex,DatadictIndex
    },
    computed: {
        currentMenuTitle() {
            const menu = this.menuList.find(m => m.key === this.activeMenu);
            return menu ? menu.title : '基础设置';
        },
        currentMenuDesc() {
            const menu = this.menuList.find(m => m.key === this.activeMenu);
            return menu ? menu.desc : '配置系统基本参数和运行环境';
        }
    },
    data() {
        return {
            active: "version",
            activeMenu: 'version',
            menuList: [
                { key: 'version', title: 'APP版本管理', icon: '⚙️', desc: 'APP版本管理' },
                { key: 'pollutionDischarge', title: '排污企业名册', icon: '⚙️', desc: '排污企业名册', isRoute: true, path:'setting/sewage-company'},
                { key: 'mapTagManagement', title: '地图标签管理', icon: '⚙️', desc: '地图标签管理', isRoute: true, path: 'setting/map-label'},
                { key: 'log', title: '系统日志', icon: '📋', desc: '查看系统操作日志' },
                { key: 'do', title: '数据字典', icon: '👤', desc: '管理系统用户账户和权限' },
                { key: 'userControl', title: '用户管理', icon: '🔔', desc: '配置系统通知和提醒' },
                { key: 'roleManagement', title: '角色管理', icon: '🔐', desc: '设置用户角色和权限' },
                { key: 'menuManagement', title: '菜单管理', icon: '🔗', desc: '配置第三方系统集成' },
                { key: 'authorityManagement', title: '权限管理', icon: '💾', desc: '管理系统数据备份' },
            ]
        };
    },
    methods: {
        handleMenuClick(menuKey) {
            const menu = this.menuList.find(m => m.key === menuKey);
            if (menu) {
                if (menu.isRoute) {
                    this.$router.push(menu.path);
                } else {
                    this.activeMenu = menuKey;
                    this.active = menuKey;
                }
            }
        }
    }
};
</script>


<style lang="less" scoped>
.wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 100%;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;

  .content-title {
    font-size: 1.8rem;
    font-weight: bold;
    background: linear-gradient(135deg, #fff, #00ff96);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 0.5rem;
  }

  .content-subtitle {
    color: #64748b;
    font-size: 0.95rem;
  }

  .weather-content {
    background: rgba(20, 35, 70, 0.5);
    //backdrop-filter: blur(10px);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 16px;
    padding: 2rem;
    margin-bottom: 1.5rem;
  }
}
</style>